import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { AuthService } from 'src/app/modules/Auth/services/auth.service';
import { SidebarService } from 'src/app/shared/services/sidebar.service';
import { UserService } from 'src/app/shared/services/user.service';
import { CreditUnionDialogComponent } from '../credit-union-dialog/credit-union-dialog.component';
import { NotifyUsersDialogComponent } from '../notify-users-dialog/notify-users-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  providers: [DialogService]
})
export class HeaderComponent {

  items: MenuItem[] = [
    { label: 'Change Credit Union', icon: 'pi pi-fw pi-refresh', styleClass: 'custom-menu-item', command: () => this.changeCreditUnion() },
    { label: 'Sign out', icon: 'pi pi-fw pi-sign-out', styleClass: 'custom-menu-item', command: () => this.signout() },
  ];

  mobileItems: MenuItem[] = [
    { label: 'Reports', command: () => this.openReportsList() },
    { label: 'Bulk Report Export', routerLink: 'bulk-export' },
    { label: 'Compliance', routerLink: 'compliance' }
  ];

  constructor(
    private sidebarService: SidebarService,
    public authService: AuthService,
    public userService: UserService,
    public dialogService: DialogService
  ) { }

  openReportsList() {
    this.sidebarService.openSidebar();
  }

  signout() {
    this.authService.signout();
  }

  getFirstLetters() {
    return this.userService.getFirstLetters(this.userService.userInfo.fullName as string);
  }

  handleMenu() {
    this.items = [
      { label: `Hey ${this.userService.userInfo?.fullName}`, styleClass: 'custom-menu-name' },
      { label: 'Manage Credit Union Users', icon: 'pi pi-fw pi-bars', styleClass: 'custom-menu-item', routerLink: '/user-management', visible: this.userService.userInfo.portalAdmin || this.userService.userInfo.hasCreditUnionAdminAccess },
      { label: 'Change Credit Union', icon: 'pi pi-fw pi-refresh', styleClass: 'custom-menu-item', command: () => this.changeCreditUnion() },
      { label: 'Notify Users', icon: 'pi pi-fw pi-bell', styleClass: 'custom-menu-item', visible: this.userService.userInfo.portalAdmin, command: () => this.notifyUsers() },
      { label: 'Sign out', icon: 'pi pi-fw pi-sign-out', styleClass: 'custom-menu-item', command: () => this.signout() },
    ];
  }

  changeCreditUnion() {
    this.dialogService.open(CreditUnionDialogComponent, {
      header: 'Select a Credit Union',
      width: '400px',
      height: '250px',
      closeOnEscape: true,
      dismissableMask: true,
      baseZIndex: 100,
      contentStyle: { overflow: 'visible' },
    });
  }

  notifyUsers() {
    this.dialogService.open(NotifyUsersDialogComponent, {
      width: '600px',
      showHeader: false,
      closeOnEscape: true,
      dismissableMask: true,
      contentStyle: { padding: '1.5rem' },
    });
  }
}

